import styled from 'styled-components'
import { ReactComponent as DefaultHeaderUser } from '~assets/images/svgs/header-user.svg'
import { ReactComponent as DefaultClose } from '~assets/images/svgs/close.svg'
import { ContainerProps } from './types'

export const Container = styled.div<ContainerProps>`
  display: none;
  flex-direction: column;
  position: fixed;
  left: 0;
  width: 100%;
  height: 100%;
  top: 0;
  z-index: 1;
  background: ${({ theme }) => theme.color.background.neutral.weak};

  @media (max-width: ${({ theme }) => theme.breakpoint.sm.maxWidth}) {
    display: ${({ $isVisible }) => $isVisible ? 'flex' : 'none'};
  }
`

export const Header = styled.div`
  padding-top: ${({ theme }) => theme.spacing.km6};
  padding-bottom: ${({ theme }) => theme.spacing.km6};
  padding-left: ${({ theme }) => theme.spacing.km4};
  padding-right: ${({ theme }) => theme.spacing.km6};
  box-shadow: 0 5px 10px rgb(0 0 0 / 12%);
  border-bottom-right-radius: 10px;
  border-bottom-left-radius: 10px;
  display: flex;
  align-items: center;
  background: ${({ theme }) => theme.color.background.neutral.default};
`

export const Division = styled.div`
  margin-left: ${({ theme }) => theme.spacing.km4};
  margin-top: ${({ theme }) => theme.spacing.km6};
  /* margin-bottom: ${({ theme }) => theme.spacing.km1}; */
`

export const Option = styled.div`
  display: flex;
  align-items: center;
  background: ${({ theme }) => theme.color.background.neutral.default};
  width: 100%;
  padding: ${({ theme }) => theme.spacing.km4};
  margin-top: ${({ theme }) => theme.spacing.km1};
  > svg {
    margin-right: ${({ theme }) => theme.spacing.km3};
  }

`
export const Close = styled(DefaultClose)`
  margin-left: auto;
`

export const HeaderUser = styled(DefaultHeaderUser)`
  border-top-left-radius: 50px;
  border-top-right-radius: 50px;
  border-bottom-right-radius: 50px;
  border-bottom-left-radius: 50px;
  align-items: center;
  background-color: #e0e0e0;
  width: 48px;
  height: 48px;
  padding: 6px;
  margin-right: ${({ theme }) => theme.spacing.km3};
`
